/** Swiper / features と揃える */
export const VIEWPORT_MOBILE_MAX = 767

/** iOS アドレスバー程度の高さ変動は無視（比率） */
const SIGNIFICANT_HEIGHT_RATIO = 0.12

let lastWidth = typeof window !== 'undefined' ? window.innerWidth : 0
let lastSignificantHeight = 0
let initialized = false

export function getViewportHeight() {
  if (typeof window === 'undefined') {
    return 0
  }
  return window.visualViewport?.height ?? window.innerHeight
}

export function isMobileViewport() {
  return window.innerWidth <= VIEWPORT_MOBILE_MAX
}

function applyAppVhVariable() {
  const h = getViewportHeight()
  document.documentElement.style.setProperty('--app-vh', `${h * 0.01}px`)
  lastSignificantHeight = h
}

/**
 * アドレスバー表示などの微小な高さ変化では false（ScrollTrigger.refresh 抑制用）
 */
export function shouldRefreshScrollLayout({ force = false } = {}) {
  if (force || typeof window === 'undefined') {
    return true
  }

  const width = window.innerWidth
  const height = getViewportHeight()

  if (width !== lastWidth) {
    lastWidth = width
    lastSignificantHeight = height
    return true
  }

  if (!isMobileViewport()) {
    const ratio = Math.abs(height - lastSignificantHeight) / (lastSignificantHeight || height)
    if (ratio > SIGNIFICANT_HEIGHT_RATIO) {
      lastSignificantHeight = height
      return true
    }
    return false
  }

  return false
}

function maybeUpdateStableViewport({ onLayoutChange } = {}) {
  const width = window.innerWidth
  const height = getViewportHeight()
  let changed = false

  if (width !== lastWidth) {
    lastWidth = width
    changed = true
  } else {
    const ratio = Math.abs(height - lastSignificantHeight) / (lastSignificantHeight || height)
    if (ratio > SIGNIFICANT_HEIGHT_RATIO) {
      changed = true
    }
  }

  if (!changed) {
    return
  }

  applyAppVhVariable()
  onLayoutChange?.()
}

/**
 * iOS Safari: スクロール中の UI 表示で lvh/svh が変わり続けるのを防ぐ --app-vh を固定
 */
export function initStableViewportHeight({ onLayoutChange } = {}) {
  if (initialized || typeof window === 'undefined') {
    return
  }
  initialized = true

  lastWidth = window.innerWidth
  applyAppVhVariable()

  const onViewportEvent = () => maybeUpdateStableViewport({ onLayoutChange })

  window.addEventListener('resize', onViewportEvent, { passive: true })
  window.visualViewport?.addEventListener('resize', onViewportEvent, { passive: true })
  window.addEventListener(
    'orientationchange',
    () => {
      setTimeout(() => {
        lastWidth = window.innerWidth
        applyAppVhVariable()
        onLayoutChange?.()
      }, 150)
    },
    { passive: true },
  )
}
